<div *ngIf="isLoading" class="loading-overlay">
  <div class="loading-spinner">
    <div class="spinner"></div>
    <p>{{ 'common.loading' | translate }}</p>
  </div>
</div>

<main class="main-content" [class.loading]="isLoading">
  <div class="confronto-card">
    <div class="confronto-header">
      <h1>{{ 'confronto.title' | translate }}</h1>
    </div>

    <div class="confronto-controls" *ngIf="audiences.length">
      <div class="control audience-select-control">
        <label>{{ 'confronto.controls.audienceLabel' | translate }}</label>
        <div class="audience-selector-field">
          <div class="audience-combobox" (click)="$event.stopPropagation()">
            <button type="button"
                    class="audience-trigger"
                    [class.is-open]="showAudienceSelector"
                    (click)="toggleAudienceSelector()">
              <span>{{ audienceSelectionSummary }}</span>
              <span aria-hidden="true">▾</span>
            </button>
            <div class="audience-dropdown" *ngIf="showAudienceSelector">
              <div class="audience-dropdown__search">
                <input type="text"
                       [value]="audienceSearchTerm"
                       (input)="onAudienceSearch($any($event.target).value)"
                       [placeholder]="'confronto.controls.searchPlaceholder' | translate">
              </div>
              <div class="dropdown-actions">
                <button type="button" class="ghost-btn compact" (click)="selectAllInsights()">
                  {{ 'confronto.controls.allInsights' | translate }}
                </button>
                <button type="button" class="ghost-btn compact" (click)="selectAllPersonas()">
                  {{ 'confronto.controls.allPersonas' | translate }}
                </button>
                <button type="button" class="ghost-btn compact" (click)="resetAudienceSelection()">
                  {{ 'confronto.controls.reset' | translate }}
                </button>
              </div>
              <div class="audience-options">
                <label class="audience-option" *ngFor="let audience of filteredAudiencesForDropdown">
                  <input type="checkbox"
                         [checked]="isAudienceSelected(audience.id)"
                         (change)="toggleAudience(audience.id)">
                  <span class="color-indicator" [style.background-color]="audience.color"></span>
                  <span [class.personas-text]="audience.type === 'personas'">{{ audience.name }}</span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="control limit-control">
        <label>{{ 'confronto.controls.limitLabel' | translate }}</label>
        <div class="limit-select">
          <select [ngModel]="selectedDisplayLimit"
                  (ngModelChange)="onLimitChange($event)"
                  [ngModelOptions]="{ standalone: true }">
            <option [ngValue]="0">{{ 'confronto.controls.limitAll' | translate }}</option>
            <option *ngFor="let option of displayLimitOptions" [ngValue]="option">
              {{ option }}
            </option>
          </select>
          <span class="suffix">{{ 'confronto.controls.limitSuffix' | translate }}</span>
        </div>
      </div>
    </div>

    <div class="confronto-grid" *ngIf="audiences.length; else emptyState">
      <div class="grid-header">
        <div class="section-header left">
          <div class="header-align">
            <h2>{{ 'confronto.sections.siteTraffic' | translate }}</h2>
            <span class="subtitle">{{ 'confronto.sections.siteTrafficSubtitle' | translate }}</span>
          </div>
        </div>
        <div class="grid-spacer"></div>
        <div class="section-header right">
          <div class="header-align">
            <h2>{{ 'confronto.sections.italianTraffic' | translate }}</h2>
            <span class="subtitle">{{ 'confronto.sections.italianTrafficSubtitle' | translate }}</span>
          </div>
        </div>
      </div>

      <ng-container *ngIf="filteredAudiences.length; else noFilteredResults">
        <div class="confronto-rows">
          <div class="confronto-row"
               *ngFor="let audience of filteredAudiences; let i = index; trackBy: trackByAudience">
            <div class="bar-side traffico"
                 (mouseenter)="showTooltip($event, audience)"
                 (mousemove)="moveTooltip($event)"
                 (mouseleave)="hideTooltip()">
              <div class="bar-wrapper left">
                <div class="bar-track"></div>
                <div class="bar"
                     [style.width.%]="audience.trafficoSito"
                     [style.background-color]="audience.color">
                </div>
                <div class="bar-value"
                     [style.right]="getLeftLabelPosition(audience.trafficoSito)">
                  <span class="value">{{ formatPercentage(audience.trafficoSito, 1) }}%</span>
                  <span class="volume">{{ formatVolume(audience.effectiveVolume) }}</span>
                </div>
              </div>
            </div>

            <div class="row-name"
                 [class.personas]="audience.type === 'personas'"
                 [class.pubbliche]="audience.type === 'audience'"
                 [title]="audience.name">
              {{ audience.name }}
            </div>

            <div class="bar-side aderenza"
                 (mouseenter)="showTooltip($event, audience)"
                 (mousemove)="moveTooltip($event)"
                 (mouseleave)="hideTooltip()">
              <div class="bar-wrapper right">
                <div class="bar-track"></div>
                <div class="bar"
                     [style.width.%]="audience.aderenzaPopolazione"
                     [style.background-color]="audience.lightColor">
                </div>
                <div class="bar-value"
                     [style.left]="getRightLabelPosition(audience.aderenzaPopolazione)">
                  <span class="value">{{ formatPercentage(audience.aderenzaPopolazione, 2) }}%</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</main>

<ng-template #emptyState>
  <div class="empty-state">
    {{ 'confronto.empty' | translate }}
  </div>
</ng-template>

<div class="confronto-tooltip" *ngIf="tooltipVisible && tooltipAudience"
     [style.left.px]="tooltipLeft" [style.top.px]="tooltipTop">
  <div class="tooltip-name">{{ tooltipAudience.name }}</div>
  <div class="tooltip-row">
    <span class="tooltip-label">{{ 'confronto.tooltip.type' | translate }}</span>
    <span class="tooltip-value">
      {{ tooltipAudience.type === 'personas'
        ? ('confronto.tooltip.types.personas' | translate)
        : ('confronto.tooltip.types.public' | translate) }}
    </span>
  </div>
  <div class="tooltip-row">
    <span class="tooltip-label">{{ 'confronto.tooltip.siteTraffic' | translate }}</span>
    <span class="tooltip-value">{{ formatPercentage(tooltipAudience.trafficoSito, 1) }}%</span>
  </div>
  <div class="tooltip-row">
    <span class="tooltip-label">{{ 'confronto.tooltip.population' | translate }}</span>
    <span class="tooltip-value">{{ formatPercentage(tooltipAudience.aderenzaPopolazione, 2) }}%</span>
  </div>
</div>

<div class="confronto-actions" *ngIf="!isLoading && audiences.length">
  <div class="legend">
    <div class="legend-item">
      <span class="legend-swatch pubbliche"></span>
      <span>{{ 'confronto.legend.public' | translate }}</span>
    </div>
    <div class="legend-item">
      <span class="legend-swatch personas"></span>
      <span>{{ 'confronto.legend.personas' | translate }}</span>
    </div>
  </div>

  <div class="bottom-icons">
    <div class="icon-item" (click)="exportToPNG()">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" stroke="#666" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <polyline points="14,2 14,8 20,8" stroke="#666" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <line x1="16" y1="13" x2="8" y2="13" stroke="#666" stroke-width="2" stroke-linecap="round"/>
        <line x1="16" y1="17" x2="8" y2="17" stroke="#666" stroke-width="2" stroke-linecap="round"/>
      </svg>
      <span>{{ 'common.png' | translate }}</span>
    </div>

    <div class="icon-item" (click)="exportToExcel()">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" stroke="#666" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <polyline points="14,2 14,8 20,8" stroke="#666" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M9 13h6v4H9z" stroke="#666" stroke-width="1" fill="#666"/>
      </svg>
      <span>{{ 'common.xls' | translate }}</span>
    </div>
  </div>
</div>

<ng-template #noFilteredResults>
  <div class="empty-state">{{ 'confronto.noResults' | translate }}</div>
</ng-template>
